// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"c4f21e10","164":"dd1d5e60","398":"2f572417","736":"38c867d6","787":"b2c3f5bb","834":"d654e807","886":"624f3a54"}[chunkId] + ".chunk.js";
};